import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils";

const badgeVariants = cva(
    "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
    {
        variants: {
            variant: {
                mini_accent: "border-transparent bg-accent text-foreground",
                default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
                background: "border-transparent bg-background text-foreground",
                secondary: "border-transparent bg-secondary text-secondary-foreground",
                confirmation: "border-transparent bg-confirmation text-confirmation-foreground",
                destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
                outline: "text-foreground",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
    return <div className={cn("cursor-default", badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
